// TODO: Should this be replaced with SnackBar
import React, { useContext, useEffect, useState } from 'react';
import { Alert, AlertTitle, IconButton, Stack } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { UserNotificationContext } from './userNotificationContext';
import styles from './userNotification.module.scss';

export const UserNotification: React.FC = () => {
  const { notifications, removeNotification } = useContext(
    UserNotificationContext,
  );
  const { t } = useTranslation();

  setTimeout(removeNotification, 10000);

  return (
    <>
      {notifications.length > 0 && (
        <div className={styles.notificationPosition}>
          {notifications.map((notification) => (
            <Stack key={notification.id} sx={{ width: '100%' }} spacing={2}>
              <Alert
                severity={notification.type}
                action={
                  <IconButton
                    aria-label={t('accessibility.CLOSE')}
                    color="inherit"
                    size="small"
                    onClick={() => {
                      removeNotification();
                    }}
                  >
                    <CancelIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {notification.title && (
                  <AlertTitle sx={{ textTransform: 'capitalize' }}>
                    {notification.title}
                  </AlertTitle>
                )}
                <span data-testid="errorNotification">
                  {notification.message}
                </span>
              </Alert>
            </Stack>
          ))}
        </div>
      )}
    </>
  );
};
